import { StickyNote } from "lucide-react";
import type { WidgetDef } from "../types";
import { NoteGlance, NoteView } from "./NoteWidget";

export interface NoteConfig {
  text: string;
}

export const NOTE_MAX = 2000;

export const parseNoteConfig = (raw: unknown): NoteConfig => {
  const t = (raw as NoteConfig | null)?.text;
  return { text: typeof t === "string" ? t.slice(0, NOTE_MAX) : "" };
};

export const noteWidget: WidgetDef<NoteConfig> = {
  type: "note",
  icon: StickyNote,
  title: "note.title",
  description: "note.description",
  sizes: ["s", "m", "l"],
  defaultSize: "m",
  defaultConfig: () => ({ text: "" }),
  parseConfig: parseNoteConfig,
  available: (me) => me.role !== "carrier",
  View: NoteView,
  Glance: NoteGlance,
};
